import { FilledLinkToMediaField } from '@prismicio/types';

import { Modal, ModalProps } from '../../../../../../design-system/components/modal/Modal';

import style from './InfluencerUgcVideoModal.module.css';

type InfluencerUgcVideoModalProps = ModalProps & {
    video: FilledLinkToMediaField;
};

export function InfluencerUgcVideoModal({
    isOpen,
    close,
    onClose,
    video,
}: InfluencerUgcVideoModalProps) {
    return (
        <Modal size="fullscreen" dark={true} isOpen={isOpen} close={close} onClose={onClose}>
            <div className={style.videoWrapper}>
                {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                <video
                    className={style.video}
                    src={video.url}
                    preload="auto"
                    controls={true}
                    autoPlay={true}
                    playsInline={true}
                    loop={false}
                    onLoadStart={(event) => {
                        event.currentTarget.volume = 0.1;
                    }}
                />
            </div>
        </Modal>
    );
}
